/**
 * Bodky zhody návrhu s exportom — len import z TopSolidu, jediné miesto
 * so skutočným skóre (KOLO 120). User: *„pri importe … sa mi páči tá
 * zhoda, tie bodky"*. Inde odporúčania ukazujú skupiny riadkov.
 */

/** Najviac bodiek — `●●●○` je 3 zo 4. */
export const BODIEK = 4;

/**
 * Skóre je neohraničené (10 za token, +20 hrúbka, 100 priama zhoda
 * kódu), takže absolútne číslo nikomu nič nepovie. Škáluje sa **voči
 * najlepšiemu kandidátovi v tomto zozname** — porovnávajú sa navzájom,
 * nie s inými položkami.
 */
export function pocetBodiek(skore: number, najlepsie: number): number {
  if (najlepsie <= 0) return 1;
  return Math.min(BODIEK, Math.max(1, Math.ceil((skore / najlepsie) * BODIEK)));
}

export function BodkyZhody({
  skore,
  najlepsie,
  dovod,
}: {
  skore: number;
  najlepsie: number;
  /** „8681 + hrúbka 18 mm" — v bubline, nie schované. */
  dovod: string;
}): JSX.Element {
  const plne = pocetBodiek(skore, najlepsie);
  return (
    <span
      title={dovod}
      className="whitespace-nowrap font-mono text-xs tracking-[1px] text-foreground/80"
    >
      <span aria-hidden>
        {"●".repeat(plne)}
        <span className="text-muted-foreground/60">{"○".repeat(BODIEK - plne)}</span>
      </span>
      <span className="sr-only">{`zhoda ${plne} z ${BODIEK}`}</span>
    </span>
  );
}
